import {
    CREATE_PROCESS_SUPPLIER_REQUEST,
    CREATE_PROCESS_SUPPLIER_SUCCESS,
    CREATE_PROCESS_SUPPLIER_FAILURE,
    DELETE_PROCESS_SUPPLIER_REQUEST,
    DELETE_PROCESS_SUPPLIER_SUCCESS,
    DELETE_PROCESS_SUPPLIER_FAILURE,
    FETCH_SINGLE_PROCESS_SUPPLIER_REQUEST,
    FETCH_SINGLE_PROCESS_SUPPLIER_SUCCESS,
    FETCH_SINGLE_PROCESS_SUPPLIER_FAILURE,
    FETCH_PROCESS_SUPPLIER_REQUEST,
    FETCH_PROCESS_SUPPLIER_SUCCESS,
    FETCH_PROCESS_SUPPLIER_FAILURE,
    UPDATE_PROCESS_SUPPLIER_REQUEST,
    UPDATE_PROCESS_SUPPLIER_SUCCESS,
    UPDATE_PROCESS_SUPPLIER_FAILURE,
    RESET_PROCESS_SUPPLIER_INFO,
    CREATE_PROCESS_SUPPLIER_FORM,
    UPDATE_PROCESS_SUPPLIER_FORM,
    FETCH_PROCESS_SUPPLIER_DROPDOWN_REQUEST,
    FETCH_PROCESS_SUPPLIER_DROPDOWN_SUCCESS,
    FETCH_PROCESS_SUPPLIER_DROPDOWN_FAILURE
} from './processSupplier.actionsType';

export const PROCESS_SUPPLIER = 'processSupplier';

let initialState = {
    loading: false,
    processSupplierList: [],
    processSupplierDropdownList: [],
    processSupplierform: {},
    selectedState: {},
    errorMessage: ''
};

export let processSupplierReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROCESS_SUPPLIER_REQUEST:
        case CREATE_PROCESS_SUPPLIER_REQUEST:
        case UPDATE_PROCESS_SUPPLIER_REQUEST:
        case FETCH_SINGLE_PROCESS_SUPPLIER_REQUEST:
        case DELETE_PROCESS_SUPPLIER_REQUEST:
        case FETCH_PROCESS_SUPPLIER_DROPDOWN_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                processSupplierList: updatePayload
            };
        case FETCH_PROCESS_SUPPLIER_DROPDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                processSupplierDropdownList: updatePayload
            };
        case CREATE_PROCESS_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                processSupplierform: {}
            };
        case UPDATE_PROCESS_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                processSupplierform: {}
            };
        case FETCH_SINGLE_PROCESS_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                processSupplierform: updatePayload
            };
        case DELETE_PROCESS_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                processSupplierform: {}
            };
        case RESET_PROCESS_SUPPLIER_INFO:
            return {
                ...state,
                processSupplierform: {}
            };
        case CREATE_PROCESS_SUPPLIER_FORM:
        case UPDATE_PROCESS_SUPPLIER_FORM:
            return {
                ...state,
                loading: false,
                processSupplierform: {
                    ...state.processSupplierform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PROCESS_SUPPLIER_FAILURE:
        case CREATE_PROCESS_SUPPLIER_FAILURE:
        case UPDATE_PROCESS_SUPPLIER_FAILURE:
        case FETCH_SINGLE_PROCESS_SUPPLIER_FAILURE:
        case DELETE_PROCESS_SUPPLIER_FAILURE:
        case FETCH_PROCESS_SUPPLIER_DROPDOWN_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
